export default {"src":"/_next/static/media/facebook.1d1a0214.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};